import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { useViewerCurrency } from '@/api/hooks/shared/useViewerCurrency'
import {
  loadCreditLimitTransfers,
  type CreditLimitLogSource,
} from './clTransfersData'
import type { CreditLimitTransferQuery } from './clTransfersTypes'

/**
 * CL Transfers — Winner credit-limit change log (PG today / BQ historical).
 *
 * Live Keycloak → Agent-API `searchCreditLimitLogs` or `searchCreditLimitLogsBQ`.
 * Demo → local fixtures. Unreachable → unavailable (never invents money rows).
 */
export function useCreditLimitTransfers(
  query: CreditLimitTransferQuery,
  source: CreditLimitLogSource = 'postgres',
) {
  const currency = useViewerCurrency()
  return useQuery({
    queryKey: keys.creditLimitTransfers({ ...query, currency, source }),
    queryFn: () => loadCreditLimitTransfers(query, currency, source),
    // No placeholder across date/source changes — stale rows looked like a broken filter.
    retry: false,
  })
}
